import styled from 'foundations-theming-specialty/utils';
export const StyledSearchForm = styled.form.withConfig({
  displayName: "StyledSearchForm",
  componentId: "sc-11uzv96-0"
})(["display:block !important;overflow:hidden;position:", ";top:0;left:0;z-index:2;width:", ";background:", ";transform:", ";will-change:height,width,transform;border:", " !important;height:", ";border-radius:", ";max-width:100%;max-height:100%;transition:", ";&::before{content:'';z-index:0;position:absolute;top:0;left:0;width:100%;height:100%;background:", ";opacity:", ";will-change:opacity;transform:translateZ(0);transition:", ";}"], ({
  isOpen
}) => isOpen ? 'absolute' : 'relative', ({
  isOpen
}) => isOpen ? '515px' : '100%', ({
  theme
}) => theme.color['global-shell-fill-surface-panel-default'], ({
  theme,
  isOpen
}) => isOpen ? `translate3d(${theme.space['600']}, ${theme.space['400']}, 0)` : 'translateZ(0)', ({
  isOpen,
  theme
}) => isOpen ? `1px solid ${theme.color['border-core-default']}` : `1px solid ${theme.color['global-shell-border-search-field-border-default']}`, ({
  isOpen
}) => isOpen ? '48px' : '32px', ({
  theme
}) => theme.borderRadius['temp-future-300'], ({
  isOpen
}) => isOpen ? `height .2s ease,
      width .2s ease,
      transform .2s ease !important` : 'none', ({
  theme
}) => theme.color['fill-surface-default'], ({
  isOpen
}) => isOpen ? 1 : 0, ({
  isOpen
}) => isOpen ? `opacity .2s ease !important` : 'none');